


























































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { getOrderOptions } from "@/request/ticketClientRequest";
import { timeFormat, dateFormat, downloadFile } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
const roleList = () => import("@/components/roleList/index.vue"); //  lee 自己存储的供应商json
@Component({
  name: "PersonalTrackingData",
  components: {
    roleList
  }
})
export default class PerformanceManagement extends Vue {
  @Provide() private orderOptions: any = []; // lee 工单分类下拉列表
  @Provide() private searchForm: any = {
    ItemId: "",
    Email: "",
    UserGroup: "",
    UserName: "",
    // adminuId: "",
    employeeID: "",
    TimeRange: []
  }; // lee 搜索表单
  @Provide() private RangeType: number = -1; // // by Hour: 1  or by Day: 2;  默认0
  @Provide() private labelPosition: string = "right"; // // by Hour: 1  or by Day: 0;
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {
    },
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1) +
            "-" +
            start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1) +
            "-" +
            end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }
    ],
    start: "00:00",
    step: "00:10",
    end: "23: 50"
  };
  @Provide() private pickDate: any = ""; // 时间范围
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private totalstats: any = ""; // 上次更新时间
  @Provide() private pickedHour: any = ""; // 上次更新时间
  @Provide() private pickTime: any = ""; // 小时
  @Provide() private statssort: any = ""; // 按xx排序
  @Provide() private pickTimeOptions: any = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23"
  ];
  @Provide() private isHoured: boolean = false; // 是否显示小时
  @Provide() private resultData: any = [];
  @Provide() private ExtNumber: any = "";
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private rank: number = 2;
  // lee 升降序 1升2降
  // 20200819 有一个兆麟的傻子要求默认成2
  @Provide() private MorkResultData: any = [
    {
      Id: 1111,
      ExtNumber: 1111,
      Utime: 1111,
      Supplier: 1111
    }
  ];
  @Provide() private isMorked: boolean = false; // lee 模拟数据
  @Provide() private isDateButton: boolean = false;
  @Provide() private isTimeInput: boolean = false;
  @Provide() private isClked: boolean = false;
  @Provide() private chosenTimeItem: number = -1;
  @Provide() private chosenTimeItemAnother: number = -1;
  @Provide() private timeList: number[] = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23
  ];
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isGetTicketListExcelActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  } //  角色
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getOrderOptions();
    // this.getExtenList(); // 获取列表数据
  }
  private mounted() {
    window.document.body.addEventListener("click", (e: any) => {
      if (e.target.id) {
        if (e.target.id === (this.$refs.timeFlag as Vue).$attrs.id) {
          this.isTimeInput = true;
        }
      } else {
        this.isTimeInput = false;
      }
    });
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  //  lee 获取工单分类下拉列表
  private async getOrderOptions() {
    let res: any = await getOrderOptions({
      token: this.token
    });
    switch (res.status) {
      case "success":
        this.orderOptions = res.data;
        break;
      case "code":
        this.$router.push("./login");
        break;
      case "error":
        this.$message.error(res.message);
        break;
    }
  }

  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    // if(this.searchForm.ItemId) {
    if (this.pickDate && this.pickDate.length > 0) {
      return true;
    } else {
      this.$message.error("Please choose the time");
      return false;
    }
  }
  // lee 刷新数据
  private refreshListAction() {}
  // lee 禁止输入时间
  private timeInputAction(evt: any) {
    evt = "";
  }
  private timeInputFocus(evt: any) {
    setTimeout(() => {
      this.isTimeInput = true;
    }, 4);
  }
  private focusinTimeItem() {
    this.isTimeInput = true;
  }
  private pickTimeItem(item: number) {
    if (!this.isClked) {
      this.chosenTimeItem = item;
      this.isClked = true;
      this.isTimeInput = true;
    } else {
      this.chosenTimeItemAnother = item;
      this.isClked = false;
      setTimeout(() => {
        this.isTimeInput = false;
      }, 30);
      this.matchPickTime();
    }
  }
  private matchPickTime() {
    if (this.chosenTimeItem > this.chosenTimeItemAnother) {
      [this.chosenTimeItemAnother, this.chosenTimeItem] = [
        this.chosenTimeItem,
        this.chosenTimeItemAnother
      ];
    }
    this.pickedHour =
      (Number(this.chosenTimeItem) > 9
        ? this.chosenTimeItem + ":00"
        : "0" + this.chosenTimeItem + ":00") +
      " - " +
      (Number(this.chosenTimeItemAnother) > 9
        ? this.chosenTimeItemAnother + ":00"
        : "0" + this.chosenTimeItemAnother + ":00");
  }
  private pickTimeItemNow() {
    this.chosenTimeItem = 0;
    this.chosenTimeItemAnother = new Date().getHours();
    setTimeout(() => {
      this.isTimeInput = false;
    }, 30);
    this.matchPickTime();
  }
  //  lee 搜索操作
  private searchFormActionByTime(num: number) {
    this.RangeType = num;
    this.pageIndex = 1;
    if (this.testSearchForm()) {
      this.getExtenList();
    }
  }
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.isSearchFormActionDone = true;
      this.pageIndex = 1;
      if (this.isHoured) {
        this.RangeType = 3;
      } else {
        this.RangeType = 4;
      }
      this.getExtenList();
    }
  }
  //  lee 清除操作
  private clearFormAction() {
    (this.$refs["searchForm"] as any).resetFields();
    this.$store.dispatch("storeRole", {
      id: 0,
      name: ""
    });
    this.searchForm.TimeRange = "";
    this.pickDate = "";
    this.pickTime = "";
    this.statssort = "";
    this.rank = 2;
    this.RangeType = -1;
  }
  //  lee 排序操作
  //  默认升序，翻页或者搜索置为默认
  private orderFormAction() {
    if (this.testSearchForm()) {
      this.pageIndex = 1;
      this.getExtenList();
    }
  }
  //  lee 清除操作
  private refreshFormAction() {
    if (this.testSearchForm()) {
      this.getExtenList();
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  //  lee 抽离查询公共处理部分
  private dwSearchAction(): any {
    let _arg: any = {
      UserName: this.searchForm.UserName,
      ItemId: Number(this.searchForm.ItemId), // 工单分类
      Statstype: Number(this.RangeType),
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      sort: "",
      rank: this.rank // 1 顺序，2 倒叙
    };
    if (this.searchForm.employeeID.trim()) {
      _arg.employeeID = this.searchForm.employeeID;
    }
    if (this.searchForm.Email) {
      _arg.Email = "" + this.searchForm.Email; // 角色
    }
    if (this.roleData && this.roleData.id) {
      _arg.UserGroupId = Number(this.roleData.id); // 角色
    }
    if (this.RangeType == 1 || this.RangeType == 3) {
      _arg.Hour = Number(this.pickTime);
    }
    if (this.pickDate && this.pickDate.length > 0) {
      // _arg.Timerange = dateFormat(this.pickDate[0].getTime()) + " - " + dateFormat(this.pickDate[1].getTime());
      _arg.Timerange =
        timeFormat(this.pickDate[0].getTime()) +
        " - " +
        timeFormat(this.pickDate[1].getTime());
    }
    return _arg;
  }
  //  lee 导出操作
  private async exportFormAction() {
    let _arg: any = this.dwSearchAction();
    const { getUrgeFollowExcel }: any = await import("@/request/getUrgeFollow");
    let response = await getUrgeFollowExcel(_arg, this);
    if (response) {
      this.isGetTicketListExcelActionDone = response.loading
        ? response.loading
        : false;
      if (response.array[3] && response.array[3].length > 0) {
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        downloadFile(blob, response.array[2]);
      } else {
        this.isGetTicketListExcelActionDone = false;
        this.$message.error(response.array[0][1]);
      }
    } else {
      this.isGetTicketListExcelActionDone = false;
    }
  }
  private isNull(val: any): boolean {
    if (val) {
      return false;
    }
    return true;
  }
  // 		enum StatsType {
  // 	TicketPerformanceDefault    = 0;  // DailySum，用不到
  // 	TicketPerformanceHourly     = 1; // 选择小时选项，需要传递小时参数
  // 	TicketPerformanceDaily      = 2; // 选择天，需要传递天参数，不需要传递小时参数
  // 	TicketPerformanceHourlySum  = 3; // 选择小时选项，需要传递小时参数
  // 	TicketPerformanceDailySum   = 4; // 选择天，需要传递天参数，不需要传递小时参数
  // }
  // StatsSort 催收类型
  // 	enum StatsSort {
  // 	StatsSortUnspecified = 0;
  // 	AssignNum = 1;
  // 	CompleteNum = 2;
  // 	LoadNum = 3;
  // 	HandleNum = 4;
  // 	NumberOfCollections = 5;
  // 	LoadLeftUnpaidPrincipal = 6;
  // 	RepayPrincipal = 7;
  // 	RepayInterest = 8;
  // 	RepayTotal = 9;
  // 	DiffTargetRepay = 10;
  // 	RepayAmountRate = 11;
  // 	TargetRepayRate = 12;
  // }
  private sortChange(val: any) {
    // if(this.pickDate&&this.pickDate.length>0){
    switch (val.prop) {
      case "loadleftunpaidprincipal":
        this.statssort = 6;
        break;
      case "repayprincipal":
        this.statssort = 7;
        break;
      case "repayinterest":
        this.statssort = 8;
        break;
      case "repaytotal":
        this.statssort = 9;
        break;
      case "repayamountrate":
        this.statssort = 11;
        break;
      case "targetrepayrate":
        this.statssort = 12;
        break;
      case "difftargetrepay":
        this.statssort = 10;
        break;
      case "assignnum":
        this.statssort = 1;
        break;
      case "numberofcollections":
        this.statssort = 5;
        break;
      case "handlenum":
        this.statssort = 4;
        break;
      case "completenum":
        this.statssort = 2;
        break;
      case "loadnum":
        this.statssort = 3;
        break;
    }
    switch (val.order) {
      case "descending":
        this.rank = 2;
        break;
      case "ascending":
        this.rank = 1;
        break;
      default:
        this.rank = 2;
        break;
    }
    this.getExtenList();
    // }else{

    // this.$message.error("Please choose the time");
    // }
  }
  // lee 获取列表
  private dwZeroNull(val: any) {
    if (!val && val != 0) {
      return "---";
    }
    return val;
  }
  private dwNull(val: any) {
    if (!val) {
      return "---";
    }
    return val;
  }
  private async getExtenList() {
    let _arg: any = this.dwSearchAction();
    const { getUrgeFollow }: any = await import("@/request/getUrgeFollow");
    let res = await getUrgeFollow(_arg, this);
    if (res) {
      // _this.RangeType = 0;
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      this.pagerCount = res.total ? res.total : res.pageout.total;
      this.updatedTime = res.updatetime ? timeFormat(res.updatetime) : "";
      if (res.totalstats) {
        this.totalstats = res.totalstats;
      }
      if (_result) {
        // lee 接口数据通了，但是没有数据，暂时Mork一份
        this.resultData = this.isMorked ? this.MorkResultData : _result;
        if (this.RangeType == 1 || this.RangeType == 2) {
          this.resultData = _result.map((item: any) => {
            item.onedayselfnotfollownum = this.dwZeroNull(
              item.onedayselfnotfollownum
            );
            item.onedayselfnotfollowrate = this.dwZeroNull(
              item.onedayselfnotfollowrate
            );
            item.threedayselfnotfollownum = this.dwZeroNull(
              item.threedayselfnotfollownum
            );
            item.threedayselfnotfollowrate = this.dwZeroNull(
              item.threedayselfnotfollowrate
            );
            item.sevendayselfnotfollownum = this.dwZeroNull(
              item.sevendayselfnotfollownum
            );
            item.sevendayselfnotfollowrate = this.dwZeroNull(
              item.sevendayselfnotfollowrate
            );
            item.onedaycontactsnotfollownum = this.dwZeroNull(
              item.onedaycontactsnotfollownum
            );
            item.onedaycontactsnotfollowrate = this.dwZeroNull(
              item.onedaycontactsnotfollowrate
            );
            item.threedaycontactsnotfollownum = this.dwZeroNull(
              item.threedaycontactsnotfollownum
            );
            item.threedaycontactsnotfollowrate = this.dwZeroNull(
              item.threedaycontactsnotfollowrate
            );
            item.sevendaycontactsnotfollownum = this.dwZeroNull(
              item.sevendaycontactsnotfollownum
            );
            item.sevendaycontactsnotfollowrate = this.dwZeroNull(
              item.sevendaycontactsnotfollowrate
            );
            return item;
          });
        } else {
          this.resultData = _result.map((item: any) => {
            item.onedayselfnotfollownum = this.dwNull(
              item.onedayselfnotfollownum
            );
            item.onedayselfnotfollowrate = this.dwNull(
              item.onedayselfnotfollowrate
            );
            item.threedayselfnotfollownum = this.dwNull(
              item.threedayselfnotfollownum
            );
            item.threedayselfnotfollowrate = this.dwNull(
              item.threedayselfnotfollowrate
            );
            item.sevendayselfnotfollownum = this.dwNull(
              item.sevendayselfnotfollownum
            );
            item.sevendayselfnotfollowrate = this.dwNull(
              item.sevendayselfnotfollowrate
            );
            item.onedaycontactsnotfollownum = this.dwNull(
              item.onedaycontactsnotfollownum
            );
            item.onedaycontactsnotfollowrate = this.dwNull(
              item.onedaycontactsnotfollowrate
            );
            item.threedaycontactsnotfollownum = this.dwNull(
              item.threedaycontactsnotfollownum
            );
            item.threedaycontactsnotfollowrate = this.dwNull(
              item.threedaycontactsnotfollowrate
            );
            item.sevendaycontactsnotfollownum = this.dwNull(
              item.sevendaycontactsnotfollownum
            );
            item.sevendaycontactsnotfollowrate = this.dwNull(
              item.sevendaycontactsnotfollowrate
            );
            return item;
          });
        }
      }
      this.isSearchFormActionDone = res.loading;
    } else {
      this.isSearchFormActionDone = false;
    }
  }

  //  处理 日期时间选择操作
  private pickerAction() {
    if (!this.pickDate) {
      this.isHoured = false;
      return;
    }
    let opt = this.pickDate;
    var _maxDate = null; //初始化
    var _maxTime = null; //初始化
    let _minDate = new Date(opt[0]);
    let _minTime =
      _minDate.getFullYear() + _minDate.getMonth() + _minDate.getDate();
    _maxDate = new Date(opt[1]);
    _maxTime =
      _maxDate.getFullYear() + _maxDate.getMonth() + _maxDate.getDate();
    if (_minTime === _maxTime) {
      this.isHoured = true;
      let _compareStamp = new Date(_minTime).getTime();
      let _hour = _minDate.getDate();
      let _now = new Date();
      let _nowTimeStamp = new Date(
        _now.getFullYear() + _now.getMonth() + _now.getDate()
      ).getTime();
      // 默认展示当前的小时，向上取整；如果不是当天展示23
      if (_compareStamp == _nowTimeStamp) {
        if (_hour == 23) {
          this.pickTime = 23;
        } else {
          this.pickTime = _now.getHours() + 1;
        }
      } else {
        this.pickTime = 23;
      }
    } else {
      this.isHoured = false;
    }
  }
  private pickerBlurAction() {
  }
  private addButton() {
    this.isDateButton = true;
  }
}
